import Vue from "vue";
import * as MutationsType from "./mutationsType";

/* eslint-disable no-param-reassign */
export default {
  [MutationsType.SET_TIMELINE](state, payload) {
    state.timeline = payload;
  },
  [MutationsType.ADD_ACTIVITY](state, payload) {
    if (!state.timelineIds.includes(payload.id) && payload.created_at) {
      state.timeline.push(payload);
      state.timelineIds.push(payload.id);
    }
  },
  [MutationsType.ADD_TIMELINE_TICKET_IDS](state, payload) {
    state.timelineTicketIds.push(payload.id);
  },
  [MutationsType.UPDATE_ACTIVITY](state, payload) {
    let activityInd = (state.timeline || []).findIndex((activity) => activity.id === payload.id);
    if (activityInd >= 0) Vue.set(state.timeline, activityInd, { ...state.timeline[activityInd], ...payload });
  },
  [MutationsType.ADD_CONTACT_ACTIVITY](state, payload) {
    if (!state.contactTlineIds.includes(payload.id) && payload.created_at) {
      state.contactTimeline.push(payload);
      state.contactTlineIds.push(payload.id);
    }
  },
};
